// ── Typography utilities ──────────────────────────────────
// Convert straight quotes and apostrophes to curly/smart equivalents.
// Apply to text before displaying or saving to Supabase.

export function smartQuotes(text) {
  if (!text) return text
  return text
    // Double quotes: opening after space/start, closing before space/end/punctuation
    .replace(/(^|[\s([{])"(?=\S)/g, '$1\u201C')   // "  →  "
    .replace(/"/g, '\u201D')                           // "  →  "
    // Single quotes / apostrophes
    .replace(/(^|[\s([{])'(?=\S)/g, '$1\u2018')    // '  →  '
    .replace(/'/g, '\u2019')                           // '  →  '
    // Em dash
    .replace(/--/g, '\u2014')                          // --  →  —
    // Ellipsis
    .replace(/\.\.\./g, '\u2026')                      // ...  →  …
}

// Apply to a block of markdown text, skipping URLs and code spans
export function smartQuotesMd(text) {
  if (!text) return text
  // Split on code spans and URLs to avoid mangling them
  const parts = text.split(/(`[^`]*`|\[[^\]]*\]\([^)]*\)|https?:\/\/\S+)/g)
  return parts.map((part, i) => {
    // Even indices are plain text, odd are code/URLs
    if (i % 2 === 1) return part
    return smartQuotes(part)
  }).join('')
}
